import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { logout } from '../state/user-session/user-session.actions';
import { v4 as uuid } from 'uuid';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  private store = inject(Store);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const headers = req.headers
      .set('X-Requested-With', 'XMLHttpRequest')
      .set(HEADER_DEVICE_ID_KEY, getOrCreateDeviceId());

    const params = req.params;

    const clonedRequest = req.clone({
      headers: headers,
      params: params,
    });

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest).pipe(
      catchError((error) => {
        if (error.status === 401) {
          this.store.dispatch(logout({ isTimedOut: true }));
        }
        return throwError(() => error);
      }),
    );
  }
}

export const HEADER_DEVICE_ID_KEY = 'UP-DEVICE-ID';
export const DEVICE_ID_KEY = 'actablTrustedDeviceId';

function getOrCreateDeviceId(): string {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}
